<style scoped>
</style>
<style>
.date-range > input {
  width: 80px !important;
}
.calendars.row.no-gutters {
  margin-left: unset !important;
  margin-right: unset !important;
}

.daterangepicker .drp-buttons .btn {
  padding: 0 10px;
}
.v-text-field.custom-select > .v-input__control > .v-input__slot:after,
.v-text-field.custom-select > .v-input__control > .v-input__slot:before {
  bottom: 9px !important;
}
.fullheight {
  height: 100%;
}

.v-text-field.custom-select {
  position: relative;
}

.v-text-field.custom-select .v-menu__content {
  top: 35px;
  left: 0;
}

.v-text-field.custom-search .v-text-field__slot input {
  border-bottom: none;
  padding: 5px 12px;
}

.v-text-field.custom-search .v-label {
  padding: 0 12px;
  top: 12px;
}

.custom-search .v-text-field__slot input:focus {
  border-bottom: none !important;
  box-shadow: none !important;
}

.export-btn {
  margin-bottom: 10px;
}
</style>
<template lang="pug">
.main-content-padded
  .vspace.large
  .row
    .col.s12
      .bcrumb
        a Reports
  .row
    .col.m3
      | Select range:
      daterangepicker(
        v-model='startend',
        :startDate='startDate',
        :endDate='endDate',
        :locale-data='locale',
        :opens='opens',
        :ranges='ranges'
      )
      .btn(slot='input', slot-scope='picker')
  .row.fullheight
    .col.s12
      .export-btn.mb-3
        downloadCsv.btn(:data='csvData')
          | Export to CSV
      //- datatable(v-bind='$data')
      //- datatable( title='Reports' :columns='tableCol' :rows='filteredList')
      //- pre {{filteredList}}
      v-card(elevation='2', outlined)
        // v-card-title
        //   | Reports
        //   v-spacer
        //   v-text-field(v-model='search', append-icon='search', label='Search', single-line='', hide-details='')
        // div.v-card-subtitle
        //   v-select(:options='dateOptions')
        v-card-title
          v-layout.justify-space-between.align-center.wrap
            v-flex.sm7 Reports
            v-flex.sm5
              v-text-field.custom-search(
                v-model='search',
                append-icon='search',
                label='Search',
                single-line='',
                hide-details=''
              )
        v-card-text
          v-data-table(
            :headers='headers',
            :items='filteredList',
            :search='search'
          )
            template(slot='items', slot-scope='props')
              td {{ props.item.deliveryJobReferenceNumber }}
              td {{ props.item.productVariantId }}
              //- td PHP {{ Number(props.item.price).toFixed(2) }}
              td PHP {{ props.item.price | convert }}
              td {{ props.item.quantity }}
              td PHP {{ (props.item.quantity * props.item.price) | convert }}
              td {{ props.item.updatedAt | flterDate }}
            v-alert(
              slot='no-results',
              :value='true',
              color='red',
              icon='warning'
            )
              | Your search for &quot;{{ search }}&quot; found no results.
          //- table
</template>
<script>
// import axios from 'axios'
import moment from 'moment'
import DataTable from 'vue-materialize-datatable'
import DateRangePicker from 'vue2-daterange-picker'
import JsonCSV from 'vue-json-csv'
require('vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css')
export default {
  meta: {
    title: 'Reports'
  },
  data () {
    return {
      data: [],
      dateOptions: ['Day', 'Month', 'Year'],
      filterBy: 'month',
      tableCol: [
        { label: 'Reference Number', field: 'deliveryJobReferenceNumber' },
        { label: 'Variant', field: 'productVariantId' },
        { label: 'Price', field: 'price' },
        { label: 'Quantity', field: 'quantity' },
        { label: 'Total', field: '(quantity * price)' },
        { label: 'Date', field: 'updatedAt' }
      ],
      startend: {
        startDate: moment().startOf('month').format('YYYY-MM-DD'),
        endDate: moment().endOf('month').format('YYYY-MM-DD')
      },
      startDate: moment().startOf('month').format('YYYY-MM-DD'),
      endDate: moment().endOf('month').format('YYYY-MM-DD'),
      opens: 'right',
      showDropdowns: true,
      locale: {
        direction: 'ltr',
        // format: 'DD-MM-YYYY',
        format: 'YYYY-MM-DD',
        separator: ' TO ',
        applyLabel: 'Apply',
        cancelLabel: 'Cancel',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: moment.weekdaysMin(),
        monthNames: moment.monthsShort(),
        firstDay: 1
      },
      ranges: {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'This month': [moment().startOf('month'), moment().endOf('month')],
        'This year': [moment().startOf('year'), moment().endOf('year')],
        'Last week': [
          moment().subtract(1, 'week').startOf('week'),
          moment().subtract(1, 'week').endOf('week')
        ],
        'Last month': [
          moment().subtract(1, 'month').startOf('month'),
          moment().subtract(1, 'month').endOf('month')
        ],
        'Last year': [
          moment().subtract(1, 'year').startOf('year'),
          moment().subtract(1, 'year').endOf('year')
        ]
      },
      search: '',
      headers: [
        {
          text: 'Reference Number',
          align: 'left',
          // sortable: false,
          value: 'deliveryJobReferenceNumber'
        },
        { text: 'Varient', value: 'productVariantId', align: 'left' },
        { text: 'Price', value: 'price', align: 'left' },
        { text: 'Quantity', value: 'quantity', align: 'left' },
        { text: 'Total', value: 'total', align: 'left' },
        { text: 'Date', value: 'updatedAt', align: 'left' }
      ]
    }
  },
  mounted () {
    this.getProducts()
  },
  methods: {
    getProducts () {
      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        return this.$http
          .get(
            `${this.$config.API_URL}/suppliers/4/orders/shop/1/status/delivered`,
            {
              headers: {
                Authorization: 'Bearer ' + accessToken
              }
            }
          )
          .then((result) => {
            this.data = result.data
          })
      })
    },
    getup (val) {}
  },
  computed: {
    filteredList () {
      var startDate = new Date(
        moment(this.startend['startDate']).format('YYYY-MM-DD')
      )
      var endDate = new Date(
        moment(this.startend['endDate']).format('YYYY-MM-DD')
      )
      if (startDate === 'Invalid Date' && endDate === 'Invalid Date') {
        return this.data
      } else {
        return this.data.filter(function (product) {
          var dateNew = moment(product.updatedAt).format('YYYY-MM-DD')
          var date = new Date(dateNew)
          return date >= startDate && date <= endDate
        })
      }
    },
    filteredListyr () {
      // var startDate = new Date('2018-10-07')
      // var endDate = new Date('2018-10-09')
      var startDate = new Date('2019')
      // var endDate = new Date(moment(this.value2).format('YYYY-MM-DD'))

      return this.data.filter(function (product) {
        var dateNew = moment(product.updatedAt).format('YYYY')
        var date = new Date(dateNew)
        return date >= startDate
      })
    },
    csvData () {
      let newList = []
      this.filteredList.map((item) => {
        const cPrice = Number(item.price).toFixed(2)
        const cTotal = Number(item.quantity * item.price).toFixed(2)
        const data = {
          referenceNumber: item.deliveryJobReferenceNumber,
          variantId: item.productVariantId,
          price: 'Php ' + cPrice,
          quantity: item.quantity,
          total: 'Php ' + cTotal,
          date: item.updatedAt
        }

        newList.push(data)
      })
      return newList
    }
  },
  filters: {
    flterDate: function (date) {
      return moment(date).format('MMMM DD YYYY')
    },
    convert: function (value) {
      return Number(value).toFixed(2)
    }
  },
  components: {
    datatable: DataTable,
    daterangepicker: DateRangePicker,
    downloadCsv: JsonCSV
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-report.vue